// Copyright © 2021 Move Closer

import { Model } from '@movecloser/front-core'

import { ICard, CardData } from '../contracts/models'

export class Card extends Model<CardData> implements ICard {
  protected boot (): void {
    this.initialValues = {}
    this.modelProperties = [
      'expirationMonth',
      'expirationYear',
      'expireAt',
      'id',
      'isActive',
      'number'
    ]
  }

  private cardTypes = [
    {
      name: 'Mastercard',
      regex: /^5[1-5]/
    },
    {
      name: 'VISA',
      regex: /^4/
    }
  ]

  public getType (): string {
    if (!this._data.number) {
      return ''
    }

    const controlNumber = this._data.number.slice(0, 3)
    const cardType = this.cardTypes.find(c => c.regex.test(controlNumber))

    return cardType?.name ?? controlNumber
  }

  public getLabel (): string {
    if (!this._data.number) {
      return ''
    }

    return `${this.getType()} •••• ${this._data.number.slice(-4)}`
  }
}
